import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  //Testing
  // const [auth, setAuth] = useState({ user: "LTA2308086X4", pass: "16dd338e66ccdb36bdf89a843428bb3eb3cbca3be49063d693867ae7c1db6dda" });
  //prod
  const [auth, setAuth] = useState({ user: "LTA2308086X4", pass: "16dd338e66ccdb36bdf89a843428bb3eb3cbca3be49063d693867ae7c1db6dda" });
  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
